const pt = {
  modal: {
    eyebrow: 'Idioma',
    title: 'Escolha seu idioma',
    subtitle: 'Selecione o idioma para ver o site.',
    helper: 'Espanhol / English / Português'
  },
  nav: {
    home: 'Inicio',
    services: 'Serviços',
    solutions: 'Soluções',
    stack: 'Stack',
    process: 'Processo',
    team: 'Nossa equipe',
    press: 'Imprensa',
    contact: 'Contato',
    menu: 'Menu',
    language: 'Idioma',
    cta: 'Agendar reunião'
  },
  hero: {
    badge: 'Desenvolvimento de software + Infraestrutura + Automação',
    title: 'Desenvolvimento de software que conecta sistemas, redes e processos industriais.',
    description:
      'Na Genius Software, somos uma empresa de desenvolvimento de software focada em desenvolvimento web, aplicativos móveis e integração de sistemas. Trabalhamos com React, Python e stacks modernos para melhorar a eficiência operacional, a segurança e a visibilidade em tempo real.',
    actions: {
      primary: 'Agendar reunião',
      secondary: 'Ver serviços',
      whatsapp: 'Falar pelo WhatsApp'
    },
    metrics: [
      { value: '+20', label: 'projetos ativos' },
      { value: '99.9%', label: 'uptime da infraestrutura' },
      { value: '48h', label: 'tempo médio de entrega' }
    ],
    highlights: [
      {
        title: 'Software sob medida',
        text: 'Desenvolvimento web e aplicativos sob medida.'
      },
      {
        title: 'Infraestrutura de TI segura',
        text: 'Redes, servidores e continuidade.'
      },
      {
        title: 'Automação industrial',
        text: 'Controle, rastreabilidade e dados.'
      }
    ],
    card: {
      title: 'Soluções integradas',
      text: 'Software, redes e automação industrial em uma única equipe de trabalho.',
      chips: ['React', 'Python', 'DevOps', 'SCADA']
    },
    hud: {
      latencyLabel: 'Latência',
      availabilityLabel: 'Disponibilidade',
      nodesLabel: 'Nós'
    }
  },
  sections: {
    services: {
      eyebrow: 'Serviços',
      title: 'Soluções de desenvolvimento de software, infraestrutura de TI e automação industrial.',
      subtitle:
        'Desenhamos cada proposta conforme seus objetivos, integrando desenvolvimento de software sob medida, desenvolvimento web, infraestrutura de TI e automação de processos.'
    },
    company: {
      eyebrow: 'Nossa empresa',
      title: 'Tecnologia com foco em resultados.',
      subtitle:
        'Somos uma empresa de desenvolvimento de software e consultoria tecnológica em Rosario, Argentina. Oferecemos soluções personalizadas para otimizar processos, melhorar a eficiência operacional e acompanhar o crescimento de empresas em um ambiente digital.'
    },
    process: {
      eyebrow: 'Processo',
      title: 'Um fluxo claro para projetos bem-sucedidos.',
      subtitle: 'Transparência, colaboração e melhoria contínua em cada etapa.'
    },
    stack: {
      eyebrow: 'Stack tecnológico',
      title: 'Tecnologias modernas e escaláveis.',
      subtitle:
        'Combinamos desenvolvimento full stack, desenvolvimento web, cloud e indústria 4.0 para criar soluções sólidas e prontas para crescer.',
      note: 'React, Python, APIs, bancos de dados, DevOps e infraestrutura de TI em um mesmo roadmap técnico.'
    },
    industries: {
      eyebrow: 'Setores',
      title: 'Experiência em múltiplas indústrias.',
      subtitle:
        'Nos adaptamos a cada operação para garantir resultados alinhados com seus objetivos estratégicos.'
    },
    team: {
      eyebrow: 'Confiança que cresce',
      metric: '+ de 50',
      title: 'empresas confiam em nossas soluções.',
      subtitle: 'Tecnologia criada para resolver desafios reais e acompanhar cada empresa em seu crescimento.'
    },
    teamMembers: {
      eyebrow: 'Nossa equipe',
      title: 'As pessoas por trás de cada solução.',
      subtitle:
        'Uma equipe multidisciplinar especializada em software, infraestrutura, negócios e automação.'
    },
    contact: {
      eyebrow: 'Contato',
      title: 'Impulsione seu negócio para o próximo nível.',
      subtitle:
        'Agende uma reunião e vamos fazer seu negócio crescer com soluções de desenvolvimento de software sob medida.'
    }
  },
  services: [
    {
      title: 'Software sob medida',
      description: 'Desenvolvimento de software, aplicativos web e mobile alinhados à sua operação.',
      points: [
        'Desenvolvimento web e aplicativos móveis',
        'UX/UI moderno e acessível',
        'Integrações e APIs seguras',
        'Painéis de controle e analítica'
      ],
      icon: 'software'
    },
    {
      title: 'Infraestrutura e redes',
      description: 'Infraestrutura de TI, arquitetura, segurança e conectividade confiável.',
      points: [
        'Desenho e implementação de redes',
        'Administração de servidores e serviços',
        'Monitoramento e suporte contínuo'
      ],
      icon: 'infra'
    },
    {
      title: 'Automação industrial',
      description: 'Indústria 4.0 com processos mais eficientes e dados em tempo real.',
      points: [
        'Integração de sensores e PLC',
        'SCADA, painéis e alertas',
        'Rastreabilidade e controle'
      ],
      icon: 'automation'
    },
    {
      title: 'Nuvem e continuidade',
      description: 'Serviços cloud e continuidade de negócios prontos para escalar.',
      points: [
        'Migrações cloud e hosting gerenciado',
        'Backups, DRP e alta disponibilidade',
        'DevOps e pipelines'
      ],
      icon: 'cloud'
    }
  ],
  differentiators: [
    {
      title: 'Equipe sênior',
      description: 'Profissionais em software, infraestrutura e automação.'
    },
    {
      title: 'Metodologia ágil',
      description: 'Sprints curtos, visibilidade total e entregas iterativas.'
    },
    {
      title: 'Segurança desde o início',
      description: 'Boas práticas, controle de acessos e monitoramento proativo.'
    }
  ],
  companyCard: {
    title: 'Modelo de serviço',
    description:
      'Comunicação fluida e acompanhamento próximo do projeto com foco em resultados mensuráveis.',
    checklist: [
      'Levantamento e diagnóstico',
      'Roadmap com entregas iterativas',
      'Documentação e capacitação',
      'Suporte e melhoria contínua'
    ]
  },
  companyStrip: {
    locationLabel: 'Localização',
    locationValue: 'Rosario, Argentina',
    contactLabel: 'Contato',
    contactValue: '3416926584'
  },
  process: [
    {
      step: '01',
      title: 'Descoberta',
      description: 'Mapeamos processos, objetivos e restrições.',
      icon: 'discover'
    },
    {
      step: '02',
      title: 'Design',
      description: 'Arquitetura, UX/UI e roadmap técnico.',
      icon: 'design'
    },
    {
      step: '03',
      title: 'Construção',
      description: 'Desenvolvimento, infraestrutura e automação.',
      icon: 'build'
    },
    {
      step: '04',
      title: 'Evolução',
      description: 'Suporte, melhorias e novas integrações.',
      icon: 'evolve'
    }
  ],
  stack: {
    items: [
      'React',
      'Python',
      'Node.js',
      'Django',
      'FastAPI',
      'PostgreSQL',
      'SQL Server',
      'Docker',
      'Kubernetes',
      'AWS',
      'Azure',
      'Grafana',
      'SCADA',
      'PLC'
    ],
    note: 'React, Python, APIs, bancos de dados, DevOps e infraestrutura de TI em um mesmo roadmap técnico.'
  },
  industries: [
    {
      title: 'Manufatura',
      description: 'Linhas produtivas, manutenção e rastreabilidade.',
      icon: 'manufacturing'
    },
    {
      title: 'Agro e alimentos',
      description: 'Controle de produção, estoque e qualidade.',
      icon: 'agro'
    },
    {
      title: 'Logística',
      description: 'Monitoramento, frotas e otimização de rotas.',
      icon: 'logistics'
    },
    {
      title: 'Energia',
      description: 'Telemetria, operações remotas e segurança.',
      icon: 'energy'
    },
    {
      title: 'Saúde',
      description: 'Integrações, relatórios e processos críticos.',
      icon: 'health'
    },
    {
      title: 'Serviços',
      description: 'Plataformas digitais para clientes e equipes.',
      icon: 'services'
    }
  ],
  team: [
    {
      name: 'Luciano Rodas',
      role: 'Arquiteto de soluções',
      initials: 'LR',
      photo: `${process.env.PUBLIC_URL}/equipo/lucho.png`
    },
    {
      name: 'Joel Mansilla',
      role: 'Desenvolvedor Backend',
      initials: 'JM',
      photo: `${process.env.PUBLIC_URL}/equipo/joel.png`
    },
    {
      name: 'Mauricio Arroyo',
      role: 'Desenvolvedor Full Stack',
      initials: 'MA',
      photo: `${process.env.PUBLIC_URL}/equipo/mauri.png`
    },
    {
      name: 'Mauro Bertolone',
      role: 'Desenvolvedor Full Stack',
      initials: 'MB',
      photo: `${process.env.PUBLIC_URL}/mauro.jpeg`,
      photoPosition: '50% 31%',
      photoScale: 2.6
    },
    {
      name: 'Clara Pereyra',
      role: 'Suporte a Aplica??es',
      initials: 'CP',
      photo: `${process.env.PUBLIC_URL}/clara.jpeg`,
      photoPosition: '50% 38%'
    },
    {
      name: 'Delfina Waters',
      role: 'Marketing e Comunicação',
      initials: 'DW',
      photo: `${process.env.PUBLIC_URL}/delfi.jpeg`,
      photoPosition: '50% 15%',
      photoScale: 1.5
    },
    {
      name: 'Brenda Avalos',
      role: 'Agente Comercial',
      initials: 'BA',
      photo: `${process.env.PUBLIC_URL}/brenda.jpeg`,
      photoPosition: '50% 40%',
      photoScale: 1.6
    },
    {
      name: 'Pablo Fratini',
      role: 'Líder de equipe',
      initials: 'PF',
      photo: `${process.env.PUBLIC_URL}/equipo/pablo.png`
    }
  ],
  press: {
    hero: {
      eyebrow: 'Imprensa',
      title: 'Materias e entrevistas sobre a Genius Software.',
      subtitle:
        'Uma selecao de publicacoes que mostram como levamos software sob medida, automacao e transformacao digital real para a industria.',
      primaryAction: 'Ir para contato',
      secondaryAction: 'Voltar ao inicio',
      featuredLabel: 'Materia em destaque',
      tags: ['Desarrollo Zonal', 'Punto Biz', 'Industria 4.0']
    },
    section: {
      eyebrow: 'Cobertura',
      title: 'Veiculos que contaram nossa historia.',
      subtitle:
        'Reunimos as materias publicadas sobre o crescimento da Genius Software, sua origem industrial e seu foco em processos produtivos concretos.'
    },
    cardButton: 'Ver materia',
    videoFallback: 'Seu navegador não pode reproduzir este vídeo.',
    cta: {
      eyebrow: 'Proximo passo',
      title: 'Quer conhecer o que estamos construindo?',
      subtitle:
        'Volte ao site principal para ver nossos servicos ou agende uma reuniao para aplicar essas solucoes na sua empresa.',
      primaryAction: 'Falar com a Genius',
      secondaryAction: 'Ver site principal'
    },
    articles: [
      {
        outlet: 'Desarrollo Zonal',
        category: 'Ciencia e Tecnologia',
        date: '21 de marco de 2026',
        title: 'La industria se transforma: dos emprendedores llevan la digitalizacion a las fabricas',
        description:
          'O Desarrollo Zonal apresentou a Genius Software como uma empresa regional que transforma processos produtivos com software sob medida e automacao industrial.',
        image: `${process.env.PUBLIC_URL}/dzprensa.png`,
        imageAlt: 'Captura da materia do Desarrollo Zonal sobre a Genius Software',
        href: 'https://desarrollozonal.com/2026/03/21/la-industria-se-transforma-dos-emprendedores-llevan-la-digitalizacion-a-las-fabricas/',
        hostLabel: 'desarrollozonal.com'
      },
      {
        outlet: 'Punto Biz',
        category: 'Atualidade',
        date: '5 de marco de 2026',
        title: 'De una metalurgica local a digitalizar la industria nacional',
        description:
          'O Punto Biz percorreu a origem da empresa, desde uma experiencia metalurgica concreta ate uma proposta escalavel para digitalizar operacoes industriais.',
        image: `${process.env.PUBLIC_URL}/puntobizprensa.png`,
        imageAlt: 'Captura da materia do Punto Biz sobre a Genius Software',
        href: 'https://puntobiz.com.ar/actualidad/de-una-metalurgica-local-a-digitalizar-la-industria-nacional-202635600',
        hostLabel: 'puntobiz.com.ar'
      },
      {
        outlet: 'ONE VISION',
        category: 'Projeto social',
        title: 'Projeto social ONE VISION',
        description:
          'Uma iniciativa que conecta tecnologia, compromisso e comunidade para gerar um impacto social positivo.',
        video: `${process.env.PUBLIC_URL}/santafe.mp4`,
        videoLabel: 'Vídeo do projeto social ONE VISION',
        hostLabel: 'Conteúdo audiovisual'
      }
    ]
  },
  contact: {
    actions: {
      email: 'Enviar email',
      call: 'Ligar agora'
    },
    form: {
      title: 'Fale com a gente',
      subtitle: 'Conte sobre seu projeto e retornamos em breve.',
      nameLabel: 'Nome',
      phoneLabel: 'Telefone',
      emailLabel: 'Email',
      messageLabel: 'Consulta',
      namePlaceholder: 'Seu nome',
      phonePlaceholder: 'Seu telefone',
      emailPlaceholder: 'Seu email',
      messagePlaceholder: 'Conte o que você precisa',
      mailSubject: 'Nova consulta web -',
      submit: 'Enviar consulta'
    },
    widget: {
      button: 'Mensagens',
      openLabel: 'Abrir formulário de contato',
      closeLabel: 'Fechar formulário de contato',
      assistant: {
        title: 'Assistente Genius',
        subtitle: 'Estou disponível, pergunte o que quiser.'
      }
    },
    card: {
      webLabel: 'Web',
      emailLabel: 'Email',
      phoneLabel: 'Telefone',
      locationLabel: 'Localização'
    },
    values: {
      web: 'www.sistemasgenius.com',
      email: 'comercial@sistemasgenius.com',
      phone: '3416926584',
      location: 'Córdoba 836, Rosario, Santa Fe, Argentina'
    }
  },
  footer: {
    brand: 'Genius Software',
    fiscalTitle: 'Dados fiscais',
    legalLines: ['Genius Software S.A.S.', 'CUIT 30-71926918-0'],
    mapTitle: 'Localização da Genius Software na Córdoba 836, Rosario',
    mapsLabel: 'Ver perfil no Google Maps',
    directionsLabel: 'Como chegar',
    description:
      'Soluções integradas de desenvolvimento de software sob medida, desenvolvimento web, infraestrutura de TI e automação industrial.',
    servicesTitle: 'Serviços',
    servicesItems: [
      'Software sob medida',
      'Infraestrutura e redes',
      'Automação industrial',
      'Nuvem e continuidade'
    ],
    contactTitle: 'Contato',
    contactItems: ['comercial@sistemasgenius.com', '3416926584']
  },
  whatsapp: {
    label: 'Abrir WhatsApp para consultas',
    text: 'Estamos disponíveis, fale com a gente'
  },
  images: {
    heroPrimaryAlt: 'Imagem principal',
    heroSecondaryAlt: 'Imagem secundária',
    splitPrimaryAlt: 'Imagem da equipe',
    splitSecondaryAlt: 'Imagem do escritório',
    industriesPrimaryAlt: 'Imagem da indústria',
    industriesSecondaryAlt: 'Imagem de tecnologia'
  }
};

export default pt;

